import { type TranslationKey } from "src/types";

export const BILLING_CURRENCY = "pln";

export function getBillingProductFeatureLabelKey(
  featureKey: string,
): TranslationKey {
  return `pricing.features.${featureKey}` as TranslationKey;
}
